'use client'

/* eslint-disable no-unneeded-ternary */
/* eslint-disable import/no-extraneous-dependencies */
import { styled, $fontSize, $fontWeightLight } from '@acko-tech/building-blocks.ui.common'
import { Text } from '@acko-tech/building-blocks.ui.typography'

export const Paragraph = styled(Text)`
  font-size: ${$fontSize.xs};
  font-weight: ${$fontWeightLight};
  margin-bottom: 15px;
  line-height: 20px;
  color: #121212;
`

export const CardWrapper = styled.div`
  & > a {
    text-decoration: none;
    color: #414a53;
  }
  padding-bottom: 35px;
  @media (max-width: 700px) {
    padding: 0 20px 28px;
  }
`

export const CardImage = styled.img`
  max-width: 100%;
  height: auto;
  border-radius: 8px;
  cursor: pointer;
  width: 375px;
  height: 200px;
  object-fit: ${props => props.defaultImage ? 'contain' : 'cover'};
  @media screen and (max-width: 426px) {
    width: 90vw;
    height: auto;
  }
`

export const CardHeading = styled.div`
  font-weight: 600;
  font-size: 20px;
  margin: 25px 0 0px;
  cursor: pointer;
  text-decoration: none;
  color: #121212;
  line-height: 28px;
`

export const ModifiedDate = styled.span`
  font-size: 11px;
  margin-bottom: 7px;
  color: #757575;
`
export const ShortDescription = styled.div`
  font-size: 14px;
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  max-height: 60px;
  margin-top: 5px;
`

export const Anchor = styled.div`
  text-decoration: none;
  color: #414a53;
`

export const AuthorName = styled.span`
  font-size: 12px;
`
